import React from 'react';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import ApiService from '../../../common/services/ApiService';
import ProgramsEmploymentFilters from './ProgramsEmploymentFilters';
import ReportConfig from '../../../common/config/Reports';
import ReportTable from '../../../common/components/table/ReportTable';

const styles = theme => ({
  exportHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`,
  },
});

class ProgramsEmployment extends React.Component {

  constructor(props) {
    super(props);
    this.api = new ApiService();
    this.state = {
      filters: { user_active_eq: "1" },
      loading: true,
      reportData: [],
      tableConfig: ReportConfig.programsEmployment
    };
  }

  componentDidMount = () => {
    this.getAllData();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters) {
      this.getAllData();
    }
  }

  splitFilters = () => {
    var q_filters = {};
    var params = {};
    if (this.state.filters != null) {
      Object.keys(this.state.filters).forEach((key) => {
        if(key === "year" || key ===  "mode" || key === "view_by") {
          params[key] = this.state.filters[key]
        } else {
          q_filters[key] = this.state.filters[key]
        }
      });
    }
    return [q_filters, params];
  };

  getAllData = () => {
    var pagination = null;

    var [q_filters, params] = this.splitFilters();

    var options = {
      filters: q_filters,
      params,
      pagination,
      sorting: {
        'direction': 'asc',
        'field': '',
      },
    };

    this.api.search('', options, 'reports/program_employment').then((data) => {
      this.setState({
        loading: false,
        reportData: data.data,
        tableConfig: this.dynamicTableConfig(data.data)
      });
    }).catch((ex) => {
      console.error(ex);
      this.setState({ loading: false });
    });
  };

  handleApplyFilters = (filters) => {
    this.setState({ filters: filters });
  };

  handleExport = () => {
    var sortingParams = { direction: 'asc', field: '' };

    var [filters, params] = this.splitFilters();

    return this.api.fullUrl(
      '/api/v1/reports/program_employment.csv',
      filters,
      params,
      null,
      sortingParams,
      null
    );
  };

  dynamicTableConfig = (data) => {

    var dynamic = [];

    if(data.length > 0) {
      Object.keys(data[0]).forEach((col) => {
        if(col.match(/^employment_type_/)) {
          dynamic[col] = {
            cellOptions: {
              padding: 'none',
            },
            textOptions: {
              fontWeight: 'normal',
              textAlign: 'center'
            }
          };
        }
      });
    }

    return { ...ReportConfig.programsEmployment, ...dynamic };
  };

  render() {
    const { classes, passportPeriod } = this.props;
    const { tableConfig, reportData } = this.state;

    if (this.state.loading == true) {
      return (<Paper>Loading...</Paper>);
    }

    return (
      <Grid
        container
        className={classes.programsEmploymentReport}
        spacing={2}
      >
        <Grid size={12}>
          <Paper>
            <ProgramsEmploymentFilters
              handleApplyFilters={this.handleApplyFilters}
              passportPeriod={passportPeriod}
            />
          </Paper>
        </Grid>
        <Grid size={12}>
          <Paper>
            <Grid
              container
              className={classes.exportHeader}
              justifyContent="space-between"
            >
              <Typography variant="h6">Programs (Employment)</Typography>
              <a href={`${this.handleExport()}`} target="_blank">
                <Button color="secondary" size="small" variant="contained">
                  <Typography variant="button">Export</Typography>
                </Button>
              </a>
            </Grid>
            <ReportTable
              reportData={reportData}
              tableConfig={tableConfig}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }

}

export default withStyles(ProgramsEmployment, styles, { withTheme: true });
